import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { selectEnvironments, selectLoadingStatuses } from '../../../reducers/global/globalReducer';
import LoadingSweep from '../../common/LoadingSweep';

export const GlobalRenderer = ({ children }: { children: React.ReactNode }) => {
  const defaultCreationEnvironmentId = useSelector(selectDefaultCreationCrmOrgId);
  const globalLoadingStatuses = useSelector(selectLoadingStatuses);
  const globalData = useSelector(selectEnvironments);
  const isGlobalLoading = globalLoadingStatuses[defaultCreationEnvironmentId ?? ''];

  if (
    !defaultCreationEnvironmentId ||
    (isGlobalLoading?.isLoading && !globalData[defaultCreationEnvironmentId]) //to prevent loading sweep from showing when the global data is refreshing
  )
    return <LoadingSweep />;

  return children;
};
